<template>
	<div id="finishDetails" style="margin-top: 20px;">
		<!-- <p class="back_box" @click="$router.go(-1)" v-if="this.$route.name != 'caseDetails'">
			<img src="../../../static/images/back.png"/>
			返回上一页
		</p> -->
		<h3 class="titleH3">{{caseDetails.victimList[0].obj.victimName}}的{{caseDetails.incidentTypeStr}} 案件档案 -案件编号：{{caseDetails.obj.caseNo}}({{caseDetails.obj.regulatorId}})</h3>
		<ul class="nav" v-if="false">
			<li class="active">案件基本信息</li>
			<li>服务清单</li>
			<li>案件轨迹(救援开始前)</li>
			<li>案件轨迹(救援开始后)</li>
			<li>费用清单</li>
			<li>工作台记录</li>
		</ul>
		<div class="coutent"  >
			<p class="first">一、案件基本信息</p>
			<div class="jbxx">
				<p class="second">A、案件基本信息</p>
				<ul>
					<li>报案时间：{{setTime(caseDetails.obj.reportTs)|| '- -'}}</li>
					<li>报案人：{{caseDetails.obj.reportUser|| '- -'}}</li>
					<li>报案电话：{{caseDetails.obj.reporterContact|| '- -'}}</li>
					<li>证件号码：{{caseDetails.victimList[0].obj.idNo || '--'}}</li>
					<li>性别：{{caseDetails.victimList[0].obj.gender == 1 ? '男':'女'}}</li>
					<li v-if="typeId != 800">出险时间：{{setTime(caseDetails.obj.incidentTs)|| '- -'}}</li>
          <li v-else>报案时间：{{setTime(caseDetails.obj.reportTs)|| '- -'}}</li>
					<li>所属保险公司：{{caseDetails.victimList[0].insuranceCompany|| '- -'}}</li>
					<li>案件来源：{{caseDetails.obj.caseSrc|| '- -'}}</li>
					<li>来源说明：{{setTxt(caseDetails.obj.caseSrcDesc) || '- -'}}</li>
				</ul>
			</div>
      <div class="jbxx jbxx1"  v-if="typeId == 900">
				<p class="second">B、出险信息</p>
				<ul>
					<li>出险地：{{caseDetails.caseCountry}} {{caseDetails.caseCity}} {{setTxt(caseDetails.generalLocation.addr)}}</li>
					<li>出险人：{{caseDetails.victimList[0].obj.victimName|| '- -'}}</li>
					<li  style="text-overflow: normal;overflow: auto;white-space: normal;width: 100%;">事故经过：{{setTxt(caseDetails.obj.incidentDesc) || '- -'}}</li>
          <li  style="text-overflow: normal;overflow: auto;white-space: normal;width: 100%;">救援需求：{{setTxt(caseDetails.obj.rescueInfo) || '- -'}}</li>
				</ul>
			</div>
			<div class="jbxx jbxx1"  v-else>
				<p class="second">B、出险信息</p>
				<ul>
					<li>出险地：{{caseDetails.caseCountry}} {{caseDetails.caseCity}} {{setTxt(caseDetails.generalLocation.addr)}}</li>
					<li>出险人：{{caseDetails.victimList[0].obj.victimName|| '- -'}}</li>
					<li v-if="typeId != 800">事故类型：
            <span>
              <span v-if="caseDetails.obj.accidentType == 100">疾病</span>
              <span v-if="caseDetails.obj.accidentType == 200">意外</span>
              <span v-if="caseDetails.obj.accidentType == 1000">其他</span>
            </span>
            <!-- <span v-else>
              {{caseDetails.obj.accidentType|| '- -'}}
            </span> -->
          
          </li>
          <li v-else> 服务类型：{{caseDetails.obj.accidentType|| '- -'}}</li>
					<!-- <li v-if="typeId != 800">受伤部位：{{setTxt(caseDetails.victimList[0].obj.injuredPart)|| '- -'}}</li> -->
					<li v-if="typeId != 800" style="text-overflow: normal;overflow: auto;white-space: normal;width: 100%;">事故经过：{{setTxt(caseDetails.obj.incidentDesc) || '- -'}}</li>
          	<li v-else style="text-overflow: normal;overflow: auto;white-space: normal;width: 100%;">服务经过：{{setTxt(caseDetails.obj.incidentDesc) || '- -'}}</li>
				</ul>
			</div>
<!-- 			<div class="jbxx">
				<p class="second">C、联系人信息</p>
				<ul>
					<li>报案时间：2015-10-20</li>
				</ul>
			</div> -->
		</div>
		<div class="coutent">
			<p class="first">二、案件类型</p>
			<div class="jbxx fwqd">
        <p class="second" v-if="caseDetails.obj.rescueType == 100">救援</p>
        <p class="second" v-if="caseDetails.obj.rescueType == 200">救助</p>
		
			</div>
      <div class="jbxx fwqd" v-if="caseDetails.obj.subIncidentType == 100"> <p class="second">传统救援救助</p></div>
        <div class="jbxx fwqd" v-if="caseDetails.obj.subIncidentType == 200"><p class="second">优先救援服务</p></div>
        <div class="jbxx fwqd" v-if="caseDetails.obj.subIncidentType == 300"><p class="second">星使服务</p></div>
        <div class="jbxx fwqd" v-if="caseDetails.obj.subIncidentType == 400"><p class="second">医疗垫付服务</p></div>
        <div class="jbxx fwqd" v-if="caseDetails.obj.subIncidentType == 500"><p class="second">健康监测服务</p></div>
        <div class="jbxx fwqd">{{caseDetails.obj.otherIncidentType}}</div>
		</div>
		<div class="coutent" >

        <el-button type="primary" style="float: right;margin-bottom: 10px;"  @click="updialog=true">添加记录</el-button>
     
			<p class="first">三、案件轨迹</p>
			<div class="table">
				<el-table :data="tableData" style="width: 100%">
				  <el-table-column label="时间" width="150">
						<template slot-scope='scope'>
              {{setTime(scope.row.content.time) }}
						</template>
					</el-table-column>
					<el-table-column label="服务方" width="100">
						<template slot-scope='scope'>
						{{scope.row.content.serviceName}}
						</template>
					</el-table-column>
					<el-table-column label="处理详情">
						<template slot-scope='scope'>
							{{scope.row.content.serviceContent}}
						</template>
					</el-table-column>
					<el-table-column label="附件资料" width="100">
						<template slot-scope='scope' >
              <span style="color:#409EFF" v-if="scope.row.content.attach == 1" @click="attach(scope.row.id)">查看附件</span>
              <span style="color:#409EFF" v-else>暂无</span>
						</template>
					</el-table-column>
          <el-table-column label="操作人" width="100">
						<template slot-scope='scope'>
							{{scope.row.content.optName}}
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>

    <div class="coutent" v-if="caseDetails.obj.subIncidentType != 300">
      <el-button type="primary" style="float: right;margin-bottom: 10px;" @click="supplierAddition();">添加</el-button>
			<p class="first">四、选择服务供应商</p>
			<div class="table">
				<el-table :data="tableData1" style="width: 100%">
					
					<el-table-column label="选择服务商">
						<template slot-scope='scope'>
							{{scope.row.content.rescueName}}
						</template>
					</el-table-column>
					<el-table-column label="费用报价">
						<template slot-scope='scope'>
							{{scope.row.content.fee}}
						</template>
					</el-table-column>
					<el-table-column label="是否选用">
						<template slot-scope='scope'>
							<span v-if="scope.row.content.selected == 1">是</span>
              <span v-if="scope.row.content.selected == 2">否</span>
						</template>
					</el-table-column>
					<el-table-column label="管理" width="300" show-overflow-tooltip>
						<template slot-scope='scope'>
              <el-button
              @click="delCaseRescueInfo(scope.row)"
              style="color:red"
              type="text"
              size="small"
              >删除</el-button>
              <el-button
              @click="editCaseRescueInfo(scope.row)"
              type="text"
              size="small"
              >编辑</el-button>
						</template>
					</el-table-column>
					
				</el-table>
			</div>
		</div>
    <div class="coutent" >
			<p class="first" v-if="caseDetails.obj.subIncidentType != 300">五、案件费用说明</p>
      <p class="first" v-else>四、星使信息</p>
      <el-button type="primary" style="float: right;margin-bottom: 10px;" @click="clickCasecosts(caseDetails.obj.subIncidentType);">编辑</el-button>
			<div class="table" v-if="caseDetails.obj.subIncidentType == 100">
        <div>
          <span>
            <span style="display: inline-block;width: 150px;">门诊费用</span>
            <el-input
            disabled
              style="display: inline-block; width: 220px"
              v-model="contentInfoList[0].outpatientExpenses"
            ></el-input>
            <el-select disabled v-model="contentInfoList[0].outpatientExpensescurrency" placeholder="请选择" style="width:105px">
              <el-option  v-for="item in huobi"  :key="item.label" :label="item.name" :value="item.label"></el-option>
            </el-select>
          </span>
        </div>
        <div style="margin-top:10px">
          <span>
            <span style="display: inline-block;width: 150px;">垫付住院费用</span>
            <el-input
            disabled
              style="display: inline-block; width: 220px"
              v-model="contentInfoList[1].hospitalization"
            ></el-input>
            <el-select disabled v-model="contentInfoList[1].hospitalizationcurrency" placeholder="请选择" style="width:105px">
            <el-option  v-for="item in huobi"  :key="item.label" :label="item.name" :value="item.label"></el-option>
            </el-select>
          </span>
        </div>
        <div style="margin-top:10px">
          <span>
            <span style="display: inline-block;width: 150px;">保司理赔总费用</span>
            <el-input
            disabled
              style="display: inline-block; width: 220px"
              v-model="contentInfoList[2].privacyClaim"
            ></el-input>
            <el-select disabled v-model="contentInfoList[2].privacyClaimcurrency" placeholder="请选择" style="width:105px">
            <el-option  v-for="item in huobi"  :key="item.label" :label="item.name" :value="item.label"></el-option>
            </el-select>
          </span>
        </div>
        <div style="margin-top:10px">
          <span>
            <span style="display: inline-block;width: 150px;">转运费用</span>
            <el-input disabled
              style="display: inline-block; width: 220px"
              v-model="contentInfoList[3].transport"
            ></el-input>
            <el-select disabled v-model="contentInfoList[3].transportcurrency" placeholder="请选择" style="width:105px">
            <el-option  v-for="item in huobi"  :key="item.label" :label="item.name" :value="item.label"></el-option>
            </el-select>
          </span>
        </div>
        <div style="margin-top:10px">
          <span>
            <span style="display: inline-block;width: 150px;">遗体送返/火化费用</span>
            <el-input disabled
              style="display: inline-block; width: 220px"
              v-model="contentInfoList[4].Returnofthebody"
            ></el-input>
            <el-select disabled v-model="contentInfoList[4].Returnofthebodycurrency" placeholder="请选择" style="width:105px">
            <el-option  v-for="item in huobi"  :key="item.label" :label="item.name" :value="item.label"></el-option>
            </el-select>
          </span>
        </div>
        <div style="margin-top:10px">
          <span>
            <span style="display: inline-block;width: 150px;">家属慰问费用</span>
            <el-input disabled
              style="display: inline-block; width: 220px"
              v-model="contentInfoList[5].familyCondolences"
            ></el-input>
            <el-select disabled v-model="contentInfoList[5].familyCondolencescurrency" placeholder="请选择" style="width:105px">
            <el-option  v-for="item in huobi"  :key="item.label" :label="item.name" :value="item.label"></el-option>
            </el-select>
          </span>
        </div>
        <div style="margin-top:10px">
          <span>
            <span style="display: inline-block;width: 150px;">家属前往处理后事</span>
            <el-input disabled
              style="display: inline-block; width: 220px"
              v-model="contentInfoList[6].Aftermath"
            ></el-input>
            <el-select disabled v-model="contentInfoList[6].Aftermathcurrency" placeholder="请选择" style="width:105px">
            <el-option  v-for="item in huobi"  :key="item.label" :label="item.name" :value="item.label"></el-option>
            </el-select>
          </span>
        </div>
        <div style="margin-top:10px">
          <span>
            <span style="display: inline-block;width: 150px;">其他服务费用</span>
            <el-input disabled
              style="display: inline-block; width: 220px"
              v-model="contentInfoList[7].otherServices"
            ></el-input>
            <el-select disabled v-model="contentInfoList[7].otherServicescurrency" placeholder="请选择" style="width:105px">
            <el-option  v-for="item in huobi"  :key="item.label" :label="item.name" :value="item.label"></el-option>
            </el-select>
          </span>
        </div>
        <div style="margin-top:10px">
          <span>
            <span style="display: inline-block;width: 150px;">其他费用说明</span>
           
            <el-input disabled 
            style="display: inline-block; width: 220px"
              type="textarea"
              :rows="2"
              placeholder="请输入内容"
              v-model="contentInfoList[8].explain">
            </el-input>
          </span>
        </div>
        <div style="margin-top:10px" v-if="contentInfoList[9]">
          <span>
            <span style="display: inline-block;width: 150px;">通融价格</span>
            <el-input
              disabled
              style="display: inline-block; width: 220px"
              v-model="contentInfoList[9].tolerantPrice"
            ></el-input>
            <el-select disabled v-model="contentInfoList[9].tolerantPricecurrency" placeholder="人民币" style="width:105px">
              <el-option  v-for="item in huobi"  :key="item.label" :label="item.name" :value="item.label"></el-option>
            </el-select>
          </span>
        </div>
      
			</div>
      <div class="table" v-if="caseDetails.obj.subIncidentType == 200">
        <div>
          <span>
            <span style="display: inline-block;width: 150px;">垫付/担保总费用</span>
            <el-input disabled
              style="display: inline-block; width: 220px"
              v-model="contentInfoList[0].Advancepayment"
            ></el-input>
            <el-select disabled v-model="contentInfoList[0].Advancepaymentcurrency" placeholder="请选择" style="width:105px">
            <el-option  v-for="item in huobi"  :key="item.label" :label="item.name" :value="item.label"></el-option>
            </el-select>
          </span>
        </div>
    
        <div style="margin-top:10px">
          <span>
            <span style="display: inline-block;width: 150px;">其他费用说明</span>
           
            <el-input disabled
            style="display: inline-block; width: 220px"
              type="textarea"
              :rows="2"
              placeholder="请输入内容"
              v-model="contentInfoList[1].otherServices">
            </el-input>
          </span>
        </div>
        <div style="margin-top:10px" v-if="contentInfoList[2]">
          <span>
            <span style="display: inline-block;width: 150px;">通融价格</span>
            <el-input disabled
              style="display: inline-block; width: 220px"
              v-model="contentInfoList[2].tolerantPrice"
            ></el-input>
            <el-select disabled v-model="contentInfoList[2].tolerantPricecurrency" placeholder="人民币" style="width:105px">
              <el-option  v-for="item in huobi"  :key="item.label" :label="item.name" :value="item.label"></el-option>
            </el-select>
          </span>
        </div>
			</div>
      <div class="table" v-if="caseDetails.obj.subIncidentType == 300">
        <div>
              <el-input
              disabled
              type="textarea"
              :rows="2"
              placeholder="请输入内容"
              v-model="Starenvoy">
            </el-input>
            </div>
        <div style="margin-top:10px">
          <span>
            <span style="display: inline-block;width: 120px;">星使服务时长</span>
            
           
            <el-input disabled
              style="display: inline-block; width: 220px"
              v-model="StarenvoyTime"
            ></el-input>
           <span>小时</span>
          </span>
        </div>
        <div style="margin-top:10px">
          <span>
            <span style="display: inline-block;width: 120px;">通融价格</span>
            <el-input
              disabled
              style="display: inline-block; width: 220px"
              v-model="tolerantPrice"
            ></el-input>
            <el-select disabled v-model="tolerantPricecurrency" placeholder="人民币" style="width:105px">
              <el-option  v-for="item in huobi"  :key="item.label" :label="item.name" :value="item.label"></el-option>
            </el-select>
          </span>
        </div>
    
      
			</div>
      <div class="table" v-if="caseDetails.obj.subIncidentType == 400">
        <div>
          <span>
            <span style="display: inline-block;width: 270px;">垫付金额（担保函上金额）</span>
            <el-input disabled
              style="display: inline-block; width: 220px"
              v-model="contentInfoList[0].Advancepaymentamount"
            ></el-input>
            <el-select disabled v-model="contentInfoList[0].Advancepaymentamountcurrency" placeholder="请选择" style="width:105px">
            <el-option  v-for="item in huobi"  :key="item.label" :label="item.name" :value="item.label"></el-option>
            </el-select>
          </span>
        </div>
    
        <div style="margin-top:10px">
          <span>
            <span style="display: inline-block;width: 270px;">PI金额（JT给MD发票金额）</span>
            <el-input disabled
              style="display: inline-block; width: 220px"
              v-model="contentInfoList[1].PIamount"
            ></el-input>
            <el-select disabled v-model="contentInfoList[1].PIamountcurrency" placeholder="请选择" style="width:105px">
            <el-option  v-for="item in huobi"  :key="item.label" :label="item.name" :value="item.label"></el-option>
            </el-select>
          </span>
        </div>

        <div style="margin-top:10px">
          <span>
            <span style="display: inline-block;width: 270px;">PI:发票号码（涉及多个需全部填写）</span>
            <el-input disabled
              style="display: inline-block; width: 660px"
              v-model="contentInfoList[2].PTinvoice"
            ></el-input>
          </span>
        </div>

        <div style="margin-top:10px">
          <span>
            <span style="display: inline-block;width: 270px;">PI:MD/保司汇入日期</span>
            <el-date-picker disabled
              v-model="contentInfoList[3].ptmdtime"
              type="date"
              placeholder="选择日期">
            </el-date-picker>
          
          </span>
        </div>

        <div style="margin-top:10px">
          <span>
            <span style="display: inline-block;width: 270px;">PI:结汇金额</span>
            <el-input disabled
              style="display: inline-block; width: 220px"
              v-model="contentInfoList[4].ptSettlementamount"
            ></el-input>
            <el-select disabled v-model="contentInfoList[4].ptSettlementamountcurrency" placeholder="请选择" style="width:105px">
            <el-option  v-for="item in huobi"  :key="item.label" :label="item.name" :value="item.label"></el-option>
            </el-select>
          </span>
        </div>

        <div style="margin-top:10px">
          <span>
            <span style="display: inline-block;width: 270px;">江泰Case Fee（外币）</span>
            <el-input disabled
              style="display: inline-block; width: 220px"
              v-model="contentInfoList[5].jtCaseFee"
            ></el-input>
            <el-select disabled v-model="contentInfoList[5].jtCaseFeecurrency" placeholder="请选择" style="width:105px">
            <el-option  v-for="item in huobi"  :key="item.label" :label="item.name" :value="item.label"></el-option>
            </el-select>
          </span>
        </div>

        <div style="margin-top:10px">
          <span>
            <span style="display: inline-block;width: 270px;">最终账单：MD汇入日期</span>
            <el-date-picker
            disabled
              v-model="contentInfoList[6].MDtime"
              type="date"
              placeholder="选择日期">
            </el-date-picker>
          </span>
        </div>

        <div style="margin-top:10px">
          <span>
            <span style="display: inline-block;width: 270px;">Case Fee结汇金额</span>
            <el-input disabled
              style="display: inline-block; width: 220px"
              v-model="contentInfoList[7].CaseFeeSettlementamount"
            ></el-input>
            <el-select disabled v-model="contentInfoList[7].CaseFeeSettlementamountcurrency" placeholder="请选择" style="width:105px">
            <el-option  v-for="item in huobi"  :key="item.label" :label="item.name" :value="item.label"></el-option>
            </el-select>
          </span>
        </div>

        <div style="margin-top:10px">
          <span>
            <span style="display: inline-block;width: 270px;">服务商垫付金额</span>
            <el-input disabled
              style="display: inline-block; width: 220px"
              v-model="contentInfoList[8].serviceProvideramount"
            ></el-input>
            <el-select disabled v-model="contentInfoList[8].serviceProvideramountcurrency" placeholder="请选择" style="width:105px">
            <el-option  v-for="item in huobi"  :key="item.label" :label="item.name" :value="item.label"></el-option>
            </el-select>
            <span style="display: inline-block;width: 95px;">折合人民币</span>
            <el-input disabled
              style="display: inline-block; width: 220px"
              v-model="contentInfoList[8].serviceProvideramountConvertedtoRMB"
            ></el-input>
          </span>
        </div>

        <div style="margin-top:10px">
          <span>
            <span style="display: inline-block;width: 270px;">服务商case fee</span>
            <el-input disabled
              style="display: inline-block; width: 220px"
              v-model="contentInfoList[9].serviceProvidercasefee"
            ></el-input>
            <el-select disabled v-model="contentInfoList[9].serviceProvidercasefeecurrency" placeholder="请选择" style="width:105px">
            <el-option  v-for="item in huobi"  :key="item.label" :label="item.name" :value="item.label"></el-option>
            </el-select>
          </span>
        </div>

        <div style="margin-top:10px">
          <span>
            <span style="display: inline-block;width: 270px;">服务商总支出费用</span>
            <el-input disabled
              style="display: inline-block; width: 220px"
              v-model="contentInfoList[10].Totalcostofserviceprovider"
            ></el-input>
            <el-select disabled v-model="contentInfoList[10].Totalcostofserviceprovidercurrency" placeholder="请选择" style="width:105px">
            <el-option  v-for="item in huobi"  :key="item.label" :label="item.name" :value="item.label"></el-option>
            </el-select>
            <span style="display: inline-block;width: 95px;">折合人民币</span>
            <el-input disabled
              style="display: inline-block; width: 220px"
              v-model="contentInfoList[10].TotalcostofserviceproviderConvertedtoRMB"
            ></el-input>
          </span>
        </div>

        <div style="margin-top:10px">
          <span>
            <span style="display: inline-block;width: 270px;">垫付折扣比例</span>
            <el-input disabled
              style="display: inline-block; width: 220px"
              v-model="contentInfoList[11].discount"
            ></el-input>
            <el-select disabled v-model="contentInfoList[11].discountcurrency" placeholder="请选择" style="width:105px">
            <el-option  v-for="item in huobi"  :key="item.label" :label="item.name" :value="item.label"></el-option>
            </el-select>
          </span>
        </div>

        <div style="margin-top:10px">
          <span>
            <span style="display: inline-block;width: 270px;">垫付折扣金额/佣金</span>
            <el-input disabled
              style="display: inline-block; width: 220px"
              v-model="contentInfoList[12].Discountamount"
            ></el-input>
            <el-select disabled v-model="contentInfoList[12].Discountamountcurrency" placeholder="请选择" style="width:105px">
            <el-option  v-for="item in huobi"  :key="item.label" :label="item.name" :value="item.label"></el-option>
            </el-select>
          </span>
        </div>
        <div style="margin-top:10px" v-if="contentInfoList[13]">
          <span>
            <span style="display: inline-block;width: 270px;">通融价格</span>
            <el-input disabled
              style="display: inline-block; width: 220px"
              v-model="contentInfoList[13].tolerantPrice"
            ></el-input>
            <el-select disabled v-model="contentInfoList[13].tolerantPricecurrency" placeholder="人民币" style="width:105px">
              <el-option  v-for="item in huobi"  :key="item.label" :label="item.name" :value="item.label"></el-option>
            </el-select>
          </span>
        </div>

			</div>
		</div> 
    <div class="coutent">
      <el-button type="primary" style="float: right;margin-bottom: 10px;" @click="dialogFormVisible2 = true">编辑</el-button>
      <p class="first" v-if="caseDetails.obj.subIncidentType != 300">六、案件总体费用成本利润</p>
      <p class="first" v-else>五、案件总体费用成本利润</p>
			<div class="table">
				<div>
          <span>
            <span style="display: inline-block;width: 150px;">服务总成本/支出</span>
            <el-input disabled
              style="display: inline-block; width: 220px"
              v-model="rescueFee"
            ></el-input>
            <el-select disabled v-model="currency" placeholder="请选择" style="width:105px">
            <el-option  v-for="item in huobi"  :key="item.label" :label="item.name" :value="item.label"></el-option>
            </el-select>
          </span>
        </div>
        <div style="margin-top:10px">
          <span>
            <span style="display: inline-block;width: 150px;">利润</span>
            <el-input disabled
              style="display: inline-block; width: 220px"
              v-model="otherFee"
            ></el-input>
            <el-select disabled v-model="currency2" placeholder="请选择" style="width:105px">
            <el-option  v-for="item in huobi"  :key="item.label" :label="item.name" :value="item.label"></el-option>
            </el-select>
          </span>
        </div>
        <div style="margin-top:10px">
          <span>
            <span style="display: inline-block;width: 150px;">服务总费用</span>
            <el-input disabled
              style="display: inline-block; width: 220px"
              v-model="medicFee"
            ></el-input>
            <el-select disabled v-model="currency3" placeholder="请选择" style="width:105px">
            <el-option  v-for="item in huobi"  :key="item.label" :label="item.name" :value="item.label"></el-option>
            </el-select>
          </span>
        </div>
      
			</div>
		</div>
    <el-dialog title="选择服务供应商" :visible.sync="dialogFormVisible">
        <el-form :model="form"> 
          <el-form-item label="选择服务商" :label-width="formLabelWidth">
            <el-input style="width: 219px;" v-model="rescueName" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="费用" :label-width="formLabelWidth">
            <el-input style="width: 219px;" v-model="fee" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="是否选用" :label-width="formLabelWidth">
            <el-select v-model="selected" placeholder="请选择">
              <el-option label="是" value="1"></el-option>
              <el-option label="否" value="2"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="saveCaseRescueInfo();dialogFormVisible = false">确 定</el-button>
        </div>
      </el-dialog>
      <el-dialog title="编辑" :visible.sync="dialogFormVisible1">
        <div class="table" v-if="caseDetails.obj.subIncidentType == 100">
        <div>
          <span>
            <span style="display: inline-block;width: 150px;">门诊费用</span>
            <el-input
              style="display: inline-block; width: 220px"
              v-model="outpatientExpenses"
            ></el-input>
            <el-select v-model="outpatientExpensescurrency" placeholder="请选择" style="width:105px">
              <el-option  v-for="item in huobi"  :key="item.label" :label="item.name" :value="item.label"></el-option>
            </el-select>
          </span>
        </div>
        <div style="margin-top:10px">
          <span>
            <span style="display: inline-block;width: 150px;">垫付住院费用</span>
            <el-input
              style="display: inline-block; width: 220px"
              v-model="hospitalization"
            ></el-input>
            <el-select v-model="hospitalizationcurrency" placeholder="请选择" style="width:105px">
            <el-option  v-for="item in huobi"  :key="item.label" :label="item.name" :value="item.label"></el-option>
            </el-select>
          </span>
        </div>
        <div style="margin-top:10px">
          <span>
            <span style="display: inline-block;width: 150px;">保司理赔总费用</span>
            <el-input
              style="display: inline-block; width: 220px"
              v-model="privacyClaim"
            ></el-input>
            <el-select v-model="privacyClaimcurrency" placeholder="请选择" style="width:105px">
            <el-option  v-for="item in huobi"  :key="item.label" :label="item.name" :value="item.label"></el-option>
            </el-select>
          </span>
        </div>
        <div style="margin-top:10px">
          <span>
            <span style="display: inline-block;width: 150px;">转运费用</span>
            <el-input
              style="display: inline-block; width: 220px"
              v-model="transport"
            ></el-input>
            <el-select v-model="transportcurrency" placeholder="请选择" style="width:105px">
            <el-option  v-for="item in huobi"  :key="item.label" :label="item.name" :value="item.label"></el-option>
            </el-select>
          </span>
        </div>
        <div style="margin-top:10px">
          <span>
            <span style="display: inline-block;width: 150px;">遗体送返/火化费用</span>
            <el-input
              style="display: inline-block; width: 220px"
              v-model="Returnofthebody"
            ></el-input>
            <el-select v-model="Returnofthebodycurrency" placeholder="请选择" style="width:105px">
            <el-option  v-for="item in huobi"  :key="item.label" :label="item.name" :value="item.label"></el-option>
            </el-select>
          </span>
        </div>
        <div style="margin-top:10px">
          <span>
            <span style="display: inline-block;width: 150px;">家属慰问费用</span>
            <el-input
              style="display: inline-block; width: 220px"
              v-model="familyCondolences"
            ></el-input>
            <el-select v-model="familyCondolencescurrency" placeholder="请选择" style="width:105px">
            <el-option  v-for="item in huobi"  :key="item.label" :label="item.name" :value="item.label"></el-option>
            </el-select>
          </span>
        </div>
        <div style="margin-top:10px">
          <span>
            <span style="display: inline-block;width: 150px;">家属前往处理后事</span>
            <el-input
              style="display: inline-block; width: 220px"
              v-model="Aftermath"
            ></el-input>
            <el-select v-model="Aftermathcurrency" placeholder="请选择" style="width:105px">
            <el-option  v-for="item in huobi"  :key="item.label" :label="item.name" :value="item.label"></el-option>
            </el-select>
          </span>
        </div>
        <div style="margin-top:10px">
          <span>
            <span style="display: inline-block;width: 150px;">其他服务费用</span>
            <el-input
              style="display: inline-block; width: 220px"
              v-model="otherServices"
            ></el-input>
            <el-select v-model="otherServicescurrency" placeholder="请选择" style="width:105px">
            <el-option  v-for="item in huobi"  :key="item.label" :label="item.name" :value="item.label"></el-option>
            </el-select>
          </span>
        </div>
        <div style="margin-top:10px">
          <span>
            <span style="display: inline-block;width: 150px;">其他费用说明</span>
           
            <el-input
            style="display: inline-block; width: 220px"
              type="textarea"
              :rows="2"
              placeholder="请输入内容"
              v-model="explain">
            </el-input>
          </span>
        </div>
        <div style="margin-top:10px">
          <span>
            <span style="display: inline-block;width: 150px;">通融价格</span>
            <el-input
              style="display: inline-block; width: 220px"
              v-model="tolerantPrice"
            ></el-input>
            <el-select v-model="tolerantPricecurrency" placeholder="人民币" style="width:105px">
              <el-option  v-for="item in huobi"  :key="item.label" :label="item.name" :value="item.label"></el-option>
            </el-select>
          </span>
        </div>
			</div>
      <div class="table" v-if="caseDetails.obj.subIncidentType == 200">
        <div>
          <span>
            <span style="display: inline-block;width: 150px;">垫付/担保总费用</span>
            <el-input
              style="display: inline-block; width: 220px"
              v-model="Advancepayment"
            ></el-input>
            <el-select v-model="Advancepaymentcurrency" placeholder="请选择" style="width:105px">
            <el-option  v-for="item in huobi"  :key="item.label" :label="item.name" :value="item.label"></el-option>
            </el-select>
          </span>
        </div>
    
        <div style="margin-top:10px">
          <span>
            <span style="display: inline-block;width: 150px;">其他费用说明</span>
           
            <el-input
            style="display: inline-block; width: 220px"
              type="textarea"
              :rows="2"
              placeholder="请输入内容"
              v-model="otherServices">
            </el-input>
          </span>
        </div>
        <div style="margin-top:10px">
          <span>
            <span style="display: inline-block;width: 150px;">通融价格</span>
            <el-input
              style="display: inline-block; width: 220px"
              v-model="tolerantPrice"
            ></el-input>
            <el-select v-model="tolerantPricecurrency" placeholder="人民币" style="width:105px">
              <el-option  v-for="item in huobi"  :key="item.label" :label="item.name" :value="item.label"></el-option>
            </el-select>
          </span>
        </div>
			</div>
      <div class="table" v-if="caseDetails.obj.subIncidentType == 300">
        <div>
              <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入内容"
              v-model="Starenvoy">
            </el-input>
            </div>
        <div style="margin-top:10px">
          <span>
            <span style="display: inline-block;width: 120px;">星使服务时长</span>
            
           
            <el-input
              style="display: inline-block; width: 220px"
              v-model="StarenvoyTime"
            ></el-input>
           <span>小时</span>
          </span>
        </div>
        <div style="margin-top:10px">
          <span>
            <span style="display: inline-block;width: 120px;">通融价格</span>
            <el-input
              style="display: inline-block; width: 220px"
              v-model="tolerantPrice"
            ></el-input>
            <el-select v-model="tolerantPricecurrency" placeholder="人民币" style="width:105px">
              <el-option  v-for="item in huobi"  :key="item.label" :label="item.name" :value="item.label"></el-option>
            </el-select>
          </span>
        </div>
    
      
			</div>
      <div class="table" v-if="caseDetails.obj.subIncidentType == 400">
        <div>
          <span>
            <span style="display: inline-block;width: 230px;">垫付金额（担保函上金额）</span>
            <el-input 
              style="display: inline-block; width: 220px"
              v-model="Advancepaymentamount"
            ></el-input>
            <el-select  v-model="Advancepaymentamountcurrency" placeholder="请选择" style="width:105px">
            <el-option  v-for="item in huobi"  :key="item.label" :label="item.name" :value="item.label"></el-option>
            </el-select>
          </span>
        </div>
       
        <div style="margin-top:10px">
          <span>
            <span style="display: inline-block;width: 230px;">PI金额（JT给MD发票金额）</span>
            <el-input 
              style="display: inline-block; width: 220px"
              v-model="PIamount"
            ></el-input>
            <el-select  v-model="PIamountcurrency" placeholder="请选择" style="width:105px">
            <el-option  v-for="item in huobi"  :key="item.label" :label="item.name" :value="item.label"></el-option>
            </el-select>
          </span>
        </div>
       
        <div style="margin-top:10px">
          <span>
            <span style="display: inline-block;width: 230px;">PI:发票号码（涉及多个需全部填写）</span>
            <el-input 
              style="display: inline-block; width: 660px"
              v-model="PTinvoice"
            ></el-input>
          </span>
        </div>

        <div style="margin-top:10px">
          <span>
            <span style="display: inline-block;width: 230px;">PI:MD/保司汇入日期</span>
            <el-date-picker 
              v-model="ptmdtime"
              type="date"
              placeholder="选择日期">
            </el-date-picker>
          
          </span>
        </div>

        <div style="margin-top:10px">
          <span>
            <span style="display: inline-block;width: 230px;">PI:结汇金额</span>
            <el-input 
              style="display: inline-block; width: 220px"
              v-model="ptSettlementamount"
            ></el-input>
            <el-select  v-model="ptSettlementamountcurrency" placeholder="请选择" style="width:105px">
            <el-option  v-for="item in huobi"  :key="item.label" :label="item.name" :value="item.label"></el-option>
            </el-select>
          </span>
        </div>
      

        <div style="margin-top:10px">
          <span>
            <span style="display: inline-block;width: 230px;">江泰Case Fee（外币）</span>
            <el-input 
              style="display: inline-block; width: 220px"
              v-model="jtCaseFee"
            ></el-input>
            <el-select  v-model="jtCaseFeecurrency" placeholder="请选择" style="width:105px">
            <el-option  v-for="item in huobi"  :key="item.label" :label="item.name" :value="item.label"></el-option>
            </el-select>
          </span>
        </div>

        <div style="margin-top:10px">
          <span>
            <span style="display: inline-block;width: 230px;">最终账单：MD汇入日期</span>
            <el-date-picker
            
              v-model="MDtime"
              type="date"
              placeholder="选择日期">
            </el-date-picker>
          </span>
        </div>

        <div style="margin-top:10px">
          <span>
            <span style="display: inline-block;width: 230px;">Case Fee结汇金额</span>
            <el-input 
              style="display: inline-block; width: 220px"
              v-model="CaseFeeSettlementamount"
            ></el-input>
            <el-select  v-model="CaseFeeSettlementamountcurrency" placeholder="请选择" style="width:105px">
            <el-option  v-for="item in huobi"  :key="item.label" :label="item.name" :value="item.label"></el-option>
            </el-select>
          </span>
        </div>
        

        <div style="margin-top:10px">
          <span>
            <span style="display: inline-block;width: 230px;">服务商垫付金额</span>
            <el-input 
              style="display: inline-block; width: 220px"
              v-model="serviceProvideramount"
            ></el-input>
            <el-select  v-model="serviceProvideramountcurrency" placeholder="请选择" style="width:105px">
            <el-option  v-for="item in huobi"  :key="item.label" :label="item.name" :value="item.label"></el-option>
            </el-select>
            <span style="display: inline-block;width: 95px;">折合人民币</span>
            <el-input 
              style="display: inline-block; width: 220px"
              v-model="serviceProvideramountConvertedtoRMB"
            ></el-input>
          </span>
        </div>

        <div style="margin-top:10px">
          <span>
            <span style="display: inline-block;width: 230px;">服务商case fee</span>
            <el-input 
              style="display: inline-block; width: 220px"
              v-model="serviceProvidercasefee"
            ></el-input>
            <el-select  v-model="serviceProvidercasefeecurrency" placeholder="请选择" style="width:105px">
            <el-option  v-for="item in huobi"  :key="item.label" :label="item.name" :value="item.label"></el-option>
            </el-select>
          </span>
        </div>

        <div style="margin-top:10px">
          <span>
            <span style="display: inline-block;width: 230px;">服务商总支出费用</span>
            <el-input 
              style="display: inline-block; width: 220px"
              v-model="Totalcostofserviceprovider"
            ></el-input>
            <el-select  v-model="Totalcostofserviceprovidercurrency" placeholder="请选择" style="width:105px">
            <el-option  v-for="item in huobi"  :key="item.label" :label="item.name" :value="item.label"></el-option>
            </el-select>
            <span style="display: inline-block;width: 95px;">折合人民币</span>
            <el-input 
              style="display: inline-block; width: 220px"
              v-model="TotalcostofserviceproviderConvertedtoRMB"
            ></el-input>
          </span>
        </div>
       

        <div style="margin-top:10px">
          <span>
            <span style="display: inline-block;width: 230px;">垫付折扣比例</span>
            <el-input 
              style="display: inline-block; width: 220px"
              v-model="discount"
            ></el-input>
            <el-select  v-model="discountcurrency" placeholder="请选择" style="width:105px">
            <el-option  v-for="item in huobi"  :key="item.label" :label="item.name" :value="item.label"></el-option>
            </el-select>
          </span>
        </div>

        <div style="margin-top:10px">
          <span>
            <span style="display: inline-block;width: 230px;">垫付折扣金额/佣金</span>
            <el-input 
              style="display: inline-block; width: 220px"
              v-model="Discountamount"
            ></el-input>
            <el-select  v-model="Discountamountcurrency" placeholder="请选择" style="width:105px">
            <el-option  v-for="item in huobi"  :key="item.label" :label="item.name" :value="item.label"></el-option>
            </el-select>
          </span>
        </div>

        <div style="margin-top:10px">
          <span>
            <span style="display: inline-block;width: 230px;">通融价格</span>
            <el-input 
              style="display: inline-block; width: 220px"
              v-model="tolerantPrice"
            ></el-input>
            <el-select  v-model="tolerantPricecurrency" placeholder="人民币" style="width:105px">
              <el-option  v-for="item in huobi"  :key="item.label" :label="item.name" :value="item.label"></el-option>
            </el-select>
          </span>
        </div>
       
			</div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible1 = false">取 消</el-button>
          <el-button type="primary" @click="saveCaseFee();dialogFormVisible1 = false">确 定</el-button>
        </div>
      </el-dialog>

      <el-dialog title="案件总体费用成本利润" :visible.sync="dialogFormVisible2">
        <div class="table">
				<div>
          <span>
            <span style="display: inline-block;width: 150px;">服务总成本/支出</span>
            <el-input
              style="display: inline-block; width: 220px"
              v-model="rescueFee"
            ></el-input>
            <el-select v-model="currency" placeholder="请选择" style="width:105px">
            <el-option  v-for="item in huobi"  :key="item.label" :label="item.name" :value="item.label"></el-option>
            </el-select>
          </span>
        </div>
        <div style="margin-top:10px">
          <span>
            <span style="display: inline-block;width: 150px;">利润</span>
            <el-input
              style="display: inline-block; width: 220px"
              v-model="otherFee"
            ></el-input>
            <el-select v-model="currency2" placeholder="请选择" style="width:105px">
            <el-option  v-for="item in huobi"  :key="item.label" :label="item.name" :value="item.label"></el-option>
            </el-select>
          </span>
        </div>
        <div style="margin-top:10px">
          <span>
            <span style="display: inline-block;width: 150px;">服务总费用</span>
            <el-input
              style="display: inline-block; width: 220px"
              v-model="medicFee"
            ></el-input>
            <el-select v-model="currency3" placeholder="请选择" style="width:105px">
            <el-option  v-for="item in huobi"  :key="item.label" :label="item.name" :value="item.label"></el-option>
            </el-select>
          </span>
        </div>
      
			</div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible2 = false">取 消</el-button>
          <el-button type="primary" @click="centerEditCaseFee();dialogFormVisible2 = false">确 定</el-button>
        </div>
      </el-dialog>

		<el-dialog title="附件查看" :visible.sync="centerDialogVisible3" center>
			<el-carousel :interval="4000" type="card" height="200px">
				<el-carousel-item v-for="(item,index) in fileArrurl" :key="index" v-if="item.status == 1">
				  <img style="width: 100%;" :src="item.url">
				</el-carousel-item>
			</el-carousel>
		</el-dialog>

    <el-dialog title="上传附件" :visible.sync="updialog" center>
			<el-form  v-show="updialog" label-width="80px" style="">
        <el-form-item style="width: 80%;margin: 0 auto 20px;" label="时间:">
          <el-date-picker
            v-model="time"
            type="datetime"
            placeholder="选择日期">
          </el-date-picker>
				</el-form-item>
				<!-- <el-form-item style="width: 80%;margin: 0 auto 20px;" label="附件内容:">
					 <el-input type="textarea" v-model="desc"></el-input>
				</el-form-item> -->
        <el-form-item style="width: 80%;margin: 0 auto 20px;" label="服务方:">
					 <el-input type="textarea" v-model="serviceName"></el-input>
				</el-form-item>
        <el-form-item style="width: 80%;margin: 0 auto 20px;" label="处理详情:">
					 <el-input type="textarea" v-model="serviceContent"></el-input>
				</el-form-item>
        <el-form-item style="width: 80%;margin: 0 auto 20px;" label="类型" >
          <el-select v-model="form.status" placeholder="请选择上类型">
              <el-option v-for="item in statusArr" :label="item.name" :value="item.static" :key="item.static"></el-option>
          </el-select>
        </el-form-item>
		  	<el-form-item>
          <!-- :on-remove="handleRemove" -->
		  	<el-upload class="upload-demo"
		  	action="aaa"
		  	:on-preview="handlePreview"
		    :on-remove="handleRemove"
		  	:before-remove="beforeRemove"
		  	multiple
		  	:limit="10"
		  	:on-exceed="handleExceed"
		  	:file-list="fileList"
		  	:before-upload="beforeAvatarUpload"
		  	:http-request="requestFile"
		  	 >
		  		<el-button size="small" type="primary":loading="uploadBtn">点击添加</el-button>
		  		<div slot="tip" class="el-upload__tip">可上传9个附件，每个附件大小不得超过8M</div>
		  	</el-upload>
			
		  </el-form-item>
			</el-form>
      <div style="width:100%;text-align: center;">
        <el-button size="small" type="primary" @click="uploadFile()">确定</el-button>
      </div>
     
		</el-dialog>

    <el-dialog title="查看附件" :visible.sync="dialogFormVisible3">
      <el-table :data="gridData">
        <el-table-column property="date" label="附件" >
          <template slot-scope='scope'>
            <img v-if="handleFileSuccess4(scope.row) == 1" style="width:100px" :src="scope.row" />
							<span v-else>{{scope.row}}</span>
						</template>
        </el-table-column>
        <el-table-column property="date" label="操作" width="150">
          <template slot-scope='scope' >
              <span style="color:#409EFF" @click="see(scope.row)">查看</span>
						</template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogFormVisible3 = false">确 定</el-button>
      </div>
    </el-dialog>
	</div>
</template>

<script>
import axios from 'axios'
import getObj from "@/util/constants.js"
import {
  getCasedetail,
  caseProgress,
  getNodeDataRegulator,
  listBidding,
  listTrack,
  saveCaseTrack,
  listAttach,
  saveCaseRescueInfo,
  listRescueInfo,
  delCaseRescueInfo,
  listCaseFee,
  saveCaseFee,
  saveXingShiInfo,
  listXingShiInfo,
  centerEditCaseFee
} from "@/views/axios/api.js";
import constants from "@/util/constants.js";
export default {
  data() {
    return {
      rescueFee:'',  ////成本   
      medicFee:'', //服务费用
      otherFee:'', //利润
      currency:'RMB',
      currency2:'RMB',
      currency3:'RMB',
      // 100
      outpatientExpenses:"",
      outpatientExpensescurrency:'RMB',
      hospitalization:'',
      hospitalizationcurrency:'RMB',
      privacyClaim:'',
      privacyClaimcurrency:'RMB',
      transport:'',
      transportcurrency:'RMB',
      Returnofthebody:'',
      Returnofthebodycurrency:'RMB',
      familyCondolences:"",
      familyCondolencescurrency:"RMB",
      Aftermath:'',
      Aftermathcurrency:'RMB',
      otherServices:'',
      otherServicescurrency:"RMB",
      explain:'',

      // 200
      Advancepayment:'',
      Advancepaymentcurrency:'',
      //  300
      Starenvoy:'',
      StarenvoyTime:'',
      tolerantPrice:'',
      tolerantPricecurrency:'RMB',
      // 400
        Advancepaymentamount:'',
        Advancepaymentamountcurrency:'RMB',
        PIamount:'',
        PIamountcurrency:'RMB',
        PTinvoice:'',
        ptmdtime:'',
        ptSettlementamount:'',
        ptSettlementamountcurrency:'RMB',
        jtCaseFee:'',
        jtCaseFeecurrency:'RMB',
        MDtime:'',
        CaseFeeSettlementamount:'',
        CaseFeeSettlementamountcurrency:'RMB',
        serviceProvideramount:'',
        serviceProvideramountcurrency:'RMB',
        serviceProvideramountConvertedtoRMB:'',
        serviceProvidercasefee:'',
        serviceProvidercasefeecurrency:'RMB',
        Totalcostofserviceprovider:'',
        Totalcostofserviceprovidercurrency:'RMB',
        TotalcostofserviceproviderConvertedtoRMB:'',
        discount:'',
        discountcurrency:'RMB',
        Discountamount:'',
        Discountamountcurrency:'RMB',
        StarenvoyList:[{Starenvoy:'',StarenvoyTime:""}],
      contentInfoList:[
        {outpatientExpenses:"",outpatientExpensescurrency:'RMB',
        hospitalization:'',hospitalizationcurrency:'RMB',
        privacyClaim:'',privacyClaimcurrency:'RMB',transport:'',
        transportcurrency:'RMB',Returnofthebody:'',Returnofthebodycurrency:'RMB',
        familyCondolences:"",familyCondolencescurrency:"RMB",Aftermath:'',Aftermathcurrency:'RMB',
        otherServices:'',otherServicescurrency:"RMB",explain:'',Advancepayment:'',Advancepaymentcurrency:'',
        Advancepaymentamount:'',Advancepaymentamountcurrency:'RMB',PIamount:'',PIamountcurrency:'RMB',
        PTinvoice:'',ptmdtime:'',ptSettlementamount:'',ptSettlementamountcurrency:'RMB',jtCaseFee:'',jtCaseFeecurrency:'RMB',
        MDtime:'',CaseFeeSettlementamount:'',CaseFeeSettlementamountcurrency:'RMB',serviceProvideramount:'',serviceProvideramountcurrency:'RMB',
        serviceProvideramountConvertedtoRMB:'',serviceProvidercasefee:'',serviceProvidercasefeecurrency:'RMB',
        Totalcostofserviceprovider:'',Totalcostofserviceprovidercurrency:'RMB',TotalcostofserviceproviderConvertedtoRMB:'',
        discount:'',discountcurrency:'RMB',Discountamount:'',Discountamountcurrency:'RMB',},{outpatientExpenses:"",
        outpatientExpensescurrency:'RMB',hospitalization:'',hospitalizationcurrency:'RMB',privacyClaim:'',privacyClaimcurrency:'RMB',transport:'',transportcurrency:'RMB',Returnofthebody:'',Returnofthebodycurrency:'RMB',familyCondolences:"",familyCondolencescurrency:"RMB",Aftermath:'',Aftermathcurrency:'RMB',otherServices:'',otherServicescurrency:"RMB",explain:'',Advancepayment:'',Advancepaymentcurrency:'',Advancepaymentamount:'',Advancepaymentamountcurrency:'RMB',PIamount:'',PIamountcurrency:'RMB',PTinvoice:'',ptmdtime:'',ptSettlementamount:'',ptSettlementamountcurrency:'RMB',jtCaseFee:'',jtCaseFeecurrency:'RMB',MDtime:'',CaseFeeSettlementamount:'',CaseFeeSettlementamountcurrency:'RMB',serviceProvideramount:'',serviceProvideramountcurrency:'RMB',serviceProvideramountConvertedtoRMB:'',serviceProvidercasefee:'',serviceProvidercasefeecurrency:'RMB',Totalcostofserviceprovider:'',Totalcostofserviceprovidercurrency:'RMB',TotalcostofserviceproviderConvertedtoRMB:'',discount:'',discountcurrency:'RMB',Discountamount:'',Discountamountcurrency:'RMB',},{outpatientExpenses:"",outpatientExpensescurrency:'RMB',hospitalization:'',hospitalizationcurrency:'RMB',privacyClaim:'',privacyClaimcurrency:'RMB',transport:'',transportcurrency:'RMB',Returnofthebody:'',Returnofthebodycurrency:'RMB',familyCondolences:"",familyCondolencescurrency:"RMB",Aftermath:'',Aftermathcurrency:'RMB',otherServices:'',otherServicescurrency:"RMB",explain:'',Advancepayment:'',Advancepaymentcurrency:'',Advancepaymentamount:'',Advancepaymentamountcurrency:'RMB',PIamount:'',PIamountcurrency:'RMB',PTinvoice:'',ptmdtime:'',ptSettlementamount:'',ptSettlementamountcurrency:'RMB',jtCaseFee:'',jtCaseFeecurrency:'RMB',MDtime:'',CaseFeeSettlementamount:'',CaseFeeSettlementamountcurrency:'RMB',serviceProvideramount:'',serviceProvideramountcurrency:'RMB',serviceProvideramountConvertedtoRMB:'',serviceProvidercasefee:'',serviceProvidercasefeecurrency:'RMB',Totalcostofserviceprovider:'',Totalcostofserviceprovidercurrency:'RMB',TotalcostofserviceproviderConvertedtoRMB:'',discount:'',discountcurrency:'RMB',Discountamount:'',Discountamountcurrency:'RMB',},{outpatientExpenses:"",outpatientExpensescurrency:'RMB',hospitalization:'',hospitalizationcurrency:'RMB',privacyClaim:'',privacyClaimcurrency:'RMB',transport:'',transportcurrency:'RMB',Returnofthebody:'',Returnofthebodycurrency:'RMB',familyCondolences:"",familyCondolencescurrency:"RMB",Aftermath:'',Aftermathcurrency:'RMB',otherServices:'',otherServicescurrency:"RMB",explain:'',Advancepayment:'',Advancepaymentcurrency:'',Advancepaymentamount:'',Advancepaymentamountcurrency:'RMB',PIamount:'',PIamountcurrency:'RMB',PTinvoice:'',ptmdtime:'',ptSettlementamount:'',ptSettlementamountcurrency:'RMB',jtCaseFee:'',jtCaseFeecurrency:'RMB',MDtime:'',CaseFeeSettlementamount:'',CaseFeeSettlementamountcurrency:'RMB',serviceProvideramount:'',serviceProvideramountcurrency:'RMB',serviceProvideramountConvertedtoRMB:'',serviceProvidercasefee:'',serviceProvidercasefeecurrency:'RMB',Totalcostofserviceprovider:'',Totalcostofserviceprovidercurrency:'RMB',TotalcostofserviceproviderConvertedtoRMB:'',discount:'',discountcurrency:'RMB',Discountamount:'',Discountamountcurrency:'RMB',},{outpatientExpenses:"",outpatientExpensescurrency:'RMB',hospitalization:'',hospitalizationcurrency:'RMB',privacyClaim:'',privacyClaimcurrency:'RMB',transport:'',transportcurrency:'RMB',Returnofthebody:'',Returnofthebodycurrency:'RMB',familyCondolences:"",familyCondolencescurrency:"RMB",Aftermath:'',Aftermathcurrency:'RMB',otherServices:'',otherServicescurrency:"RMB",explain:'',Advancepayment:'',Advancepaymentcurrency:'',Advancepaymentamount:'',Advancepaymentamountcurrency:'RMB',PIamount:'',PIamountcurrency:'RMB',PTinvoice:'',ptmdtime:'',ptSettlementamount:'',ptSettlementamountcurrency:'RMB',jtCaseFee:'',jtCaseFeecurrency:'RMB',MDtime:'',CaseFeeSettlementamount:'',CaseFeeSettlementamountcurrency:'RMB',serviceProvideramount:'',serviceProvideramountcurrency:'RMB',serviceProvideramountConvertedtoRMB:'',serviceProvidercasefee:'',serviceProvidercasefeecurrency:'RMB',Totalcostofserviceprovider:'',Totalcostofserviceprovidercurrency:'RMB',TotalcostofserviceproviderConvertedtoRMB:'',discount:'',discountcurrency:'RMB',Discountamount:'',Discountamountcurrency:'RMB',},{outpatientExpenses:"",outpatientExpensescurrency:'RMB',hospitalization:'',hospitalizationcurrency:'RMB',privacyClaim:'',privacyClaimcurrency:'RMB',transport:'',transportcurrency:'RMB',Returnofthebody:'',Returnofthebodycurrency:'RMB',familyCondolences:"",familyCondolencescurrency:"RMB",Aftermath:'',Aftermathcurrency:'RMB',otherServices:'',otherServicescurrency:"RMB",explain:'',Advancepayment:'',Advancepaymentcurrency:'',Advancepaymentamount:'',Advancepaymentamountcurrency:'RMB',PIamount:'',PIamountcurrency:'RMB',PTinvoice:'',ptmdtime:'',ptSettlementamount:'',ptSettlementamountcurrency:'RMB',jtCaseFee:'',jtCaseFeecurrency:'RMB',MDtime:'',CaseFeeSettlementamount:'',CaseFeeSettlementamountcurrency:'RMB',serviceProvideramount:'',serviceProvideramountcurrency:'RMB',serviceProvideramountConvertedtoRMB:'',serviceProvidercasefee:'',serviceProvidercasefeecurrency:'RMB',Totalcostofserviceprovider:'',Totalcostofserviceprovidercurrency:'RMB',TotalcostofserviceproviderConvertedtoRMB:'',discount:'',discountcurrency:'RMB',Discountamount:'',Discountamountcurrency:'RMB',},{outpatientExpenses:"",outpatientExpensescurrency:'RMB',hospitalization:'',hospitalizationcurrency:'RMB',privacyClaim:'',privacyClaimcurrency:'RMB',transport:'',transportcurrency:'RMB',Returnofthebody:'',Returnofthebodycurrency:'RMB',familyCondolences:"",familyCondolencescurrency:"RMB",Aftermath:'',Aftermathcurrency:'RMB',otherServices:'',otherServicescurrency:"RMB",explain:'',Advancepayment:'',Advancepaymentcurrency:'',Advancepaymentamount:'',Advancepaymentamountcurrency:'RMB',PIamount:'',PIamountcurrency:'RMB',PTinvoice:'',ptmdtime:'',ptSettlementamount:'',ptSettlementamountcurrency:'RMB',jtCaseFee:'',jtCaseFeecurrency:'RMB',MDtime:'',CaseFeeSettlementamount:'',CaseFeeSettlementamountcurrency:'RMB',serviceProvideramount:'',serviceProvideramountcurrency:'RMB',serviceProvideramountConvertedtoRMB:'',serviceProvidercasefee:'',serviceProvidercasefeecurrency:'RMB',Totalcostofserviceprovider:'',Totalcostofserviceprovidercurrency:'RMB',TotalcostofserviceproviderConvertedtoRMB:'',discount:'',discountcurrency:'RMB',Discountamount:'',Discountamountcurrency:'RMB',},{outpatientExpenses:"",outpatientExpensescurrency:'RMB',hospitalization:'',hospitalizationcurrency:'RMB',privacyClaim:'',privacyClaimcurrency:'RMB',transport:'',transportcurrency:'RMB',Returnofthebody:'',Returnofthebodycurrency:'RMB',familyCondolences:"",familyCondolencescurrency:"RMB",Aftermath:'',Aftermathcurrency:'RMB',otherServices:'',otherServicescurrency:"RMB",explain:'',Advancepayment:'',Advancepaymentcurrency:'',Advancepaymentamount:'',Advancepaymentamountcurrency:'RMB',PIamount:'',PIamountcurrency:'RMB',PTinvoice:'',ptmdtime:'',ptSettlementamount:'',ptSettlementamountcurrency:'RMB',jtCaseFee:'',jtCaseFeecurrency:'RMB',MDtime:'',CaseFeeSettlementamount:'',CaseFeeSettlementamountcurrency:'RMB',serviceProvideramount:'',serviceProvideramountcurrency:'RMB',serviceProvideramountConvertedtoRMB:'',serviceProvidercasefee:'',serviceProvidercasefeecurrency:'RMB',Totalcostofserviceprovider:'',Totalcostofserviceprovidercurrency:'RMB',TotalcostofserviceproviderConvertedtoRMB:'',discount:'',discountcurrency:'RMB',Discountamount:'',Discountamountcurrency:'RMB',},{outpatientExpenses:"",outpatientExpensescurrency:'RMB',hospitalization:'',hospitalizationcurrency:'RMB',privacyClaim:'',privacyClaimcurrency:'RMB',transport:'',transportcurrency:'RMB',Returnofthebody:'',Returnofthebodycurrency:'RMB',familyCondolences:"",familyCondolencescurrency:"RMB",Aftermath:'',Aftermathcurrency:'RMB',otherServices:'',otherServicescurrency:"RMB",explain:'',Advancepayment:'',Advancepaymentcurrency:'',Advancepaymentamount:'',Advancepaymentamountcurrency:'RMB',PIamount:'',PIamountcurrency:'RMB',PTinvoice:'',ptmdtime:'',ptSettlementamount:'',ptSettlementamountcurrency:'RMB',jtCaseFee:'',jtCaseFeecurrency:'RMB',MDtime:'',CaseFeeSettlementamount:'',CaseFeeSettlementamountcurrency:'RMB',serviceProvideramount:'',serviceProvideramountcurrency:'RMB',serviceProvideramountConvertedtoRMB:'',serviceProvidercasefee:'',serviceProvidercasefeecurrency:'RMB',Totalcostofserviceprovider:'',Totalcostofserviceprovidercurrency:'RMB',TotalcostofserviceproviderConvertedtoRMB:'',discount:'',discountcurrency:'RMB',Discountamount:'',Discountamountcurrency:'RMB',},{outpatientExpenses:"",outpatientExpensescurrency:'RMB',hospitalization:'',hospitalizationcurrency:'RMB',privacyClaim:'',privacyClaimcurrency:'RMB',transport:'',transportcurrency:'RMB',Returnofthebody:'',Returnofthebodycurrency:'RMB',familyCondolences:"",familyCondolencescurrency:"RMB",Aftermath:'',Aftermathcurrency:'RMB',otherServices:'',otherServicescurrency:"RMB",explain:'',Advancepayment:'',Advancepaymentcurrency:'',Advancepaymentamount:'',Advancepaymentamountcurrency:'RMB',PIamount:'',PIamountcurrency:'RMB',PTinvoice:'',ptmdtime:'',ptSettlementamount:'',ptSettlementamountcurrency:'RMB',jtCaseFee:'',jtCaseFeecurrency:'RMB',MDtime:'',CaseFeeSettlementamount:'',CaseFeeSettlementamountcurrency:'RMB',serviceProvideramount:'',serviceProvideramountcurrency:'RMB',serviceProvideramountConvertedtoRMB:'',serviceProvidercasefee:'',serviceProvidercasefeecurrency:'RMB',Totalcostofserviceprovider:'',Totalcostofserviceprovidercurrency:'RMB',TotalcostofserviceproviderConvertedtoRMB:'',discount:'',discountcurrency:'RMB',Discountamount:'',Discountamountcurrency:'RMB',},{outpatientExpenses:"",outpatientExpensescurrency:'RMB',hospitalization:'',hospitalizationcurrency:'RMB',privacyClaim:'',privacyClaimcurrency:'RMB',transport:'',transportcurrency:'RMB',Returnofthebody:'',Returnofthebodycurrency:'RMB',familyCondolences:"",familyCondolencescurrency:"RMB",Aftermath:'',Aftermathcurrency:'RMB',otherServices:'',otherServicescurrency:"RMB",explain:'',Advancepayment:'',Advancepaymentcurrency:'',Advancepaymentamount:'',Advancepaymentamountcurrency:'RMB',PIamount:'',PIamountcurrency:'RMB',PTinvoice:'',ptmdtime:'',ptSettlementamount:'',ptSettlementamountcurrency:'RMB',jtCaseFee:'',jtCaseFeecurrency:'RMB',MDtime:'',CaseFeeSettlementamount:'',CaseFeeSettlementamountcurrency:'RMB',serviceProvideramount:'',serviceProvideramountcurrency:'RMB',serviceProvideramountConvertedtoRMB:'',serviceProvidercasefee:'',serviceProvidercasefeecurrency:'RMB',Totalcostofserviceprovider:'',Totalcostofserviceprovidercurrency:'RMB',TotalcostofserviceproviderConvertedtoRMB:'',discount:'',discountcurrency:'RMB',Discountamount:'',Discountamountcurrency:'RMB',},{outpatientExpenses:"",outpatientExpensescurrency:'RMB',hospitalization:'',hospitalizationcurrency:'RMB',privacyClaim:'',privacyClaimcurrency:'RMB',transport:'',transportcurrency:'RMB',Returnofthebody:'',Returnofthebodycurrency:'RMB',familyCondolences:"",familyCondolencescurrency:"RMB",Aftermath:'',Aftermathcurrency:'RMB',otherServices:'',otherServicescurrency:"RMB",explain:'',Advancepayment:'',Advancepaymentcurrency:'',Advancepaymentamount:'',Advancepaymentamountcurrency:'RMB',PIamount:'',PIamountcurrency:'RMB',PTinvoice:'',ptmdtime:'',ptSettlementamount:'',ptSettlementamountcurrency:'RMB',jtCaseFee:'',jtCaseFeecurrency:'RMB',MDtime:'',CaseFeeSettlementamount:'',CaseFeeSettlementamountcurrency:'RMB',serviceProvideramount:'',serviceProvideramountcurrency:'RMB',serviceProvideramountConvertedtoRMB:'',serviceProvidercasefee:'',serviceProvidercasefeecurrency:'RMB',Totalcostofserviceprovider:'',Totalcostofserviceprovidercurrency:'RMB',TotalcostofserviceproviderConvertedtoRMB:'',discount:'',discountcurrency:'RMB',Discountamount:'',Discountamountcurrency:'RMB',},{outpatientExpenses:"",outpatientExpensescurrency:'RMB',hospitalization:'',hospitalizationcurrency:'RMB',privacyClaim:'',privacyClaimcurrency:'RMB',transport:'',transportcurrency:'RMB',Returnofthebody:'',Returnofthebodycurrency:'RMB',familyCondolences:"",familyCondolencescurrency:"RMB",Aftermath:'',Aftermathcurrency:'RMB',otherServices:'',otherServicescurrency:"RMB",explain:'',Advancepayment:'',Advancepaymentcurrency:'',Advancepaymentamount:'',Advancepaymentamountcurrency:'RMB',PIamount:'',PIamountcurrency:'RMB',PTinvoice:'',ptmdtime:'',ptSettlementamount:'',ptSettlementamountcurrency:'RMB',jtCaseFee:'',jtCaseFeecurrency:'RMB',MDtime:'',CaseFeeSettlementamount:'',CaseFeeSettlementamountcurrency:'RMB',serviceProvideramount:'',serviceProvideramountcurrency:'RMB',serviceProvideramountConvertedtoRMB:'',serviceProvidercasefee:'',serviceProvidercasefeecurrency:'RMB',Totalcostofserviceprovider:'',Totalcostofserviceprovidercurrency:'RMB',TotalcostofserviceproviderConvertedtoRMB:'',discount:'',discountcurrency:'RMB',Discountamount:'',Discountamountcurrency:'RMB'},{tolerantPrice:'',tolerantPricecurrency:'RMB'}],
      rescueName:"",// 服务方 
      fee:"", //费用
      selected:"2", //是否选择
      dialogFormVisible3:false,
      gridData:[],
      time:'',// 时间
        serviceName:'',// 服务方 
        serviceContent:'',// 处理详情 
        urls:'',// 附件
        form: {
         type:'',
         status:'',
        },
        fileInd:'',
		    tableData:[],
		    caseid:'',
				authorArr:[],
				centerDialogVisible3:false,
				fileList: [],
				fileUrl:[],
				uploadBtn:false,
				fileArrurl:[],
				updialog:false,
				desc:'',
				caseState:'',
        statusArr:[ {static:4,name:'一般附件上传'},
          {static:15,name:'跟地接社工作人员照片上传'},
          {static:16,name:'患者家属照片'},
          {static:17,name:'所在医疗机构及科室的照片'},
          {static:18,name:'医疗证明及其他相关材料照片'},
          {static:19,name:'所去的殡仪及其它政府机构的照片'},
          {static:20,name:'死亡证明相关材料照片'},],
      formLabelWidth:'100px',
      dialogFormVisible1:false,
      dialogFormVisible:false,
      dialogFormVisible2:false,
      typeId: "",
      token: JSON.parse(window.localStorage.getItem("data")).data,
      caseDetails: {
        generalLocation: {},
        obj: {},
        victimList: [{ obj: {} }],
      },
      stepData: [{ dict: {} }],
      tableData1: [], //案件开始前
      nameData: ["供应商", "", "监管机构"],
      huobi:[{
						name: '人民币',
						label: 'RMB'
					},
					{
						name: '美元',
						label: 'USD'
					},
					{
						name: '欧元',
						label: 'EUR'
					},
					{
						name: '日元',
						label: 'JPY'
					},
					{
						name: '新台币',
						label: 'TWD'
					},
          {
						name: '港币',
						label: 'HKD'
					},
          {
						name: '奈拉',
						label: 'NGN'
					},
           ],
      centerDialogVisible3: false,
      fileArrurl: [],
      labelForFive: "1",
      mongeyObj: {},
      shijiMoney: {},
      afterMoney: {},
      otherFeeBoss: [],
      caseid: "",
      listCaseFeeId:'',
      editName:1,
      serviceproviderid:'',
    };
  },
  props: ["detailList", "caseId"],
  mounted() {
   
    this.getData1();
    var data={
					caseId:this.$route.query.caseid,
					token:this.token,
          type:1
				}
				listTrack(data)
				.then( res =>{
          console.log(res.data.obj,'11111111111111111111111')
          for(var i=0;i<res.data.obj.length;i++){
          // console.log(eval('(' + res.data.obj[i].content + ')'))
          res.data.obj[i].content = JSON.parse(res.data.obj[i].content)
				}
					this.tableData=res.data.obj;
          console.log(this.tableData)
				})
				.catch( err =>{
					console.log(err)
				})
        this.listRescueInfo()
      
    this.caseid = this.$route.query.caseid;
    // this.getData()
    console.log(this.detailList);
    // this.caseDetails = this.detailList.obj;
 
    if (
      this.$route.name != "caseDetails" &&
      this.$route.name != "createDetails"
    ) {
      return this.getData1();
    } else {
      if (this.detailList.obj.obj.incidentType == "") return;
      this.getCopss();
      console.log(this.detailList);
     
     
      console.log(this.caseDetails)
      this.stepData = this.detailList.obj2;
      this.afterMoney = this.detailList.obj.obj;
      this.caseState = this.detailList.obj.obj.caseState;
      if (this.detailList.obj.feelst.length == 0) return;
      this.shijiMoney = this.detailList.obj.feelst[0];
    }
  
  },
  methods: {
    isImageFile(url){
      // 获取文件扩展名
      const extension = url.substring(url.lastIndexOf('.') + 1).toLowerCase();
      // 支持的图片扩展名列表
      const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp'];
      // 判断当前文件扩展名是否为图片扩展名
      if (imageExtensions.includes(extension)) {
        return true;
      }
      return false;
    },
handleFileSuccess4(response) {
      if (this.isImageFile(response)) {
        return 1
        // 是图片
      } else {
        // 不是图片
        return 0
      }
 
    },
    centerEditCaseFee() {
      var data={
        id:this.$route.query.caseid,
					token:this.token,
          rescueFee:this.rescueFee,//  成本   
          medicFee:this.medicFee,// 服务费用
          otherFee:this.otherFee,// 利润
          currency:this.currency,
          currency2:this.currency2,
          currency3:this.currency3
				}
				centerEditCaseFee(data)
				.then( res =>{
          this.$message({
									message: '编辑成功',
									type: 'success'
								});
				})
				.catch( err =>{
					console.log(err)
				})
    },
    clickCasecosts(type) {
      this.dialogFormVisible1 = true
       if(type == 100) {
         if(this.contentInfoList.length >= 9) {
          this.outpatientExpenses = this.contentInfoList[0].outpatientExpenses
          this.outpatientExpensescurrency = this.contentInfoList[0].outpatientExpensescurrency
          this.hospitalization = this.contentInfoList[1].hospitalization
          this.hospitalizationcurrency = this.contentInfoList[1].hospitalizationcurrency
          this.privacyClaim = this.contentInfoList[2].privacyClaim
          this.privacyClaimcurrency = this.contentInfoList[2].privacyClaimcurrency
          this.transport = this.contentInfoList[3].transport
          this.transportcurrency = this.contentInfoList[3].transportcurrency
          this.Returnofthebody = this.contentInfoList[4].Returnofthebody
          this.Returnofthebodycurrency = this.contentInfoList[4].Returnofthebodycurrency
          this.familyCondolences = this.contentInfoList[5].familyCondolences
          this.familyCondolencescurrency = this.contentInfoList[5].familyCondolencescurrency
          this.Aftermath = this.contentInfoList[6].Aftermath
          this.Aftermathcurrency = this.contentInfoList[6].Aftermathcurrency
          this.otherServices = this.contentInfoList[7].otherServices
          this.otherServicescurrency = this.contentInfoList[7].otherServicescurrency
          this.explain = this.contentInfoList[8].explain
          if (this.contentInfoList[9]) {
            this.tolerantPrice = this.contentInfoList[9].tolerantPrice
            this.tolerantPricecurrency = this.contentInfoList[9].tolerantPricecurrency || 'RMB'
          } else {
            this.tolerantPrice = ''
            this.tolerantPricecurrency = 'RMB'
          }
         }
       }else if(type == 200) {
       if(this.contentInfoList.length >= 2) {
          this.Advancepayment = this.contentInfoList[0].Advancepayment
          this.Advancepaymentcurrency = this.contentInfoList[0].Advancepaymentcurrency
          this.otherServices = this.contentInfoList[1].otherServices
          if (this.contentInfoList[2]) {
            this.tolerantPrice = this.contentInfoList[2].tolerantPrice
            this.tolerantPricecurrency = this.contentInfoList[2].tolerantPricecurrency || 'RMB'
          } else {
            this.tolerantPrice = ''
            this.tolerantPricecurrency = 'RMB'
          }
        }
       }else if(type == 400) {
       if(this.contentInfoList.length >= 13) {
          this.Advancepaymentamount =  this.contentInfoList[0].Advancepaymentamount,
          this.Advancepaymentamountcurrency = this.contentInfoList[0].Advancepaymentamountcurrency,
          this.PIamount = this.contentInfoList[1].PIamount,
          this.PIamountcurrency = this.contentInfoList[1].PIamountcurrency,
          this.PTinvoice = this.contentInfoList[2].PTinvoice
          console.log(this.contentInfoList[3].ptmdtime)
          if(this.contentInfoList[3].ptmdtime == '') {
            this.ptmdtime = ''
          }else {
            this.ptmdtime = this.setTime(this.contentInfoList[3].ptmdtime)
          }
         
          this.ptSettlementamount = this.contentInfoList[4].ptSettlementamount,
          this.ptSettlementamountcurrency = this.contentInfoList[4].ptSettlementamountcurrency,
          this.jtCaseFee = this.contentInfoList[5].jtCaseFee,
          this.jtCaseFeecurrency = this.contentInfoList[5].jtCaseFeecurrency
          if(this.contentInfoList[6].MDtime == '') {
            this.MDtime = ''
          }else {
            this.MDtime = this.setTime(this.contentInfoList[6].MDtime)
          }
         
          this.CaseFeeSettlementamount = this.contentInfoList[7].CaseFeeSettlementamount,
          this.CaseFeeSettlementamountcurrency = this.contentInfoList[7].CaseFeeSettlementamountcurrency,
          this.serviceProvideramount = this.contentInfoList[8].serviceProvideramount,
          this.serviceProvideramountcurrency = this.contentInfoList[8].serviceProvideramountcurrency,
          this.serviceProvideramountConvertedtoRMB = this.contentInfoList[8].serviceProvideramountConvertedtoRMB,
          this.serviceProvidercasefee = this.contentInfoList[9].serviceProvidercasefee,
          this.serviceProvidercasefeecurrency = this.contentInfoList[9].serviceProvidercasefeecurrency,
          this.Totalcostofserviceprovider = this.contentInfoList[10].Totalcostofserviceprovider,
          this.Totalcostofserviceprovidercurrency = this.contentInfoList[10].Totalcostofserviceprovidercurrency,
          this.TotalcostofserviceproviderConvertedtoRMB = this.contentInfoList[10].TotalcostofserviceproviderConvertedtoRMB,
          this.discount = this.contentInfoList[11].discount,
          this.discountcurrency = this.contentInfoList[11].discountcurrency,
          this.Discountamount = this.contentInfoList[12].Discountamount,
          this.Discountamountcurrency = this.contentInfoList[12].Discountamountcurrency
          if (this.contentInfoList[13]) {
            this.tolerantPrice = this.contentInfoList[13].tolerantPrice
            this.tolerantPricecurrency = this.contentInfoList[13].tolerantPricecurrency || 'RMB'
          } else {
            this.tolerantPrice = ''
            this.tolerantPricecurrency = 'RMB'
          }
        }
       }
    },
    saveCaseFee() {
      if(this.caseDetails.obj.subIncidentType == 100) {
        var contentInfo = [
           {name:'门诊费用',outpatientExpenses:this.outpatientExpenses,outpatientExpensescurrency:this.outpatientExpensescurrency},
           {name:'垫付住院费用',hospitalization:this.hospitalization,hospitalizationcurrency:this.hospitalizationcurrency},
           {name:'保司理赔总费用',privacyClaim:this.privacyClaim,privacyClaimcurrency:this.privacyClaimcurrency},
           {name:'转运费用',transport:this.transport,transportcurrency:this.transportcurrency},
           {name:'遗体送返/火化费用',Returnofthebody:this.Returnofthebody,Returnofthebodycurrency:this.Returnofthebodycurrency},
           {name:'家属慰问费用',familyCondolences:this.familyCondolences,familyCondolencescurrency:this.familyCondolencescurrency},
           {name:'家属前往处理后事',Aftermath:this.Aftermath,Aftermathcurrency:this.Aftermathcurrency},
           {name:'其他服务费用',otherServices:this.otherServices,otherServicescurrency:this.otherServicescurrency},
           {name:'其他费用说明',explain:this.explain},
           {name:'通融价格',tolerantPrice:this.tolerantPrice,tolerantPricecurrency:this.tolerantPricecurrency}
        ]
      }else if(this.caseDetails.obj.subIncidentType == 200) {
        var contentInfo = [
           {name:'垫付/担保总费用',Advancepayment:this.Advancepayment,Advancepaymentcurrency:this.Advancepaymentcurrency},
           {name:'其他费用说明',otherServices:this.otherServices},
           {name:'通融价格',tolerantPrice:this.tolerantPrice,tolerantPricecurrency:this.tolerantPricecurrency},
        ]
      }else if(this.caseDetails.obj.subIncidentType == 400) {
        var contentInfo = [
          {name:'垫付金额（担保函上金额）',Advancepaymentamount:this.Advancepaymentamount,Advancepaymentamountcurrency:this.Advancepaymentamountcurrency},
          {name:'PI金额（JT给MD发票金额）',PIamount:this.PIamount,PIamountcurrency:this.PIamountcurrency},
          {name:'PI:发票号码（涉及多个需全部填写）',PTinvoice:this.PTinvoice},
          {name:'PI:MD/保司汇入日期',ptmdtime:this.setTime(this.ptmdtime)},
          {name:'PI:结汇金额',ptSettlementamount:this.ptSettlementamount,ptSettlementamountcurrency:this.ptSettlementamountcurrency},
          {name:'江泰Case Fee（外币）',jtCaseFee:this.jtCaseFee,jtCaseFeecurrency:this.jtCaseFeecurrency},
          {name:'最终账单：MD汇入日期',MDtime:this.setTime(this.MDtime)},
          {name:'Case Fee结汇金额',CaseFeeSettlementamount:this.CaseFeeSettlementamount,CaseFeeSettlementamountcurrency:this.CaseFeeSettlementamountcurrency},
          {name:'服务商垫付金额',serviceProvideramount:this.serviceProvideramount,serviceProvideramountcurrency:this.serviceProvideramountcurrency,serviceProvideramountConvertedtoRMB:this.serviceProvideramountConvertedtoRMB},
          {name:'服务商case fee',serviceProvidercasefee:this.serviceProvidercasefee,serviceProvidercasefeecurrency:this.serviceProvidercasefeecurrency},
          {name:'服务商总支出费用',Totalcostofserviceprovider:this.Totalcostofserviceprovider,Totalcostofserviceprovidercurrency:this.Totalcostofserviceprovidercurrency,TotalcostofserviceproviderConvertedtoRMB:this.TotalcostofserviceproviderConvertedtoRMB},
          {name:'垫付折扣比例',discount:this.discount,discountcurrency:this.discountcurrency},
          {name:'垫付折扣金额/佣金',Discountamount:this.Discountamount,Discountamountcurrency:this.Discountamountcurrency},
          {name:'通融价格',tolerantPrice:this.tolerantPrice,tolerantPricecurrency:this.tolerantPricecurrency},
        ]
      }
      // else if(this.caseDetails.obj.subIncidentType == 300) {
      //   var contentInfo = [
      //     {name:'星使信息',Starenvoy:this.Starenvoy},
      //     {name:'星使服务时长',StarenvoyTime:this.StarenvoyTime}
      //   ]
      // }
      if(this.caseDetails.obj.subIncidentType == 100 || this.caseDetails.obj.subIncidentType == 200 || this.caseDetails.obj.subIncidentType == 400) {
        var data={
					caseId:this.caseid,
					token:JSON.parse(window.localStorage.getItem("data")).data,
          contentInfo:JSON.stringify(contentInfo), //费用信息
          infoId:this.listCaseFeeId
				}
				saveCaseFee(data)
				.then( res =>{
          this.$message({
									message: '编辑成功',
									type: 'success'
								});
                this.listCaseFee()
				})
				.catch( err =>{
					console.log(err)
				})
      }else {
        var data={
					caseId:this.caseid,
					token:JSON.parse(window.localStorage.getItem("data")).data,
          contentInfo:this.Starenvoy, //信息
          hours:this.StarenvoyTime, //服务时长 
          tolerantPrice:this.tolerantPrice,
          tolerantPricecurrency:this.tolerantPricecurrency,
          infoId:this.listCaseFeeId
				}
				saveXingShiInfo(data)
				.then( res =>{
          this.$message({
									message: '编辑成功',
									type: 'success'
								});
                this.listXingShiInfo()
				})
				.catch( err =>{
					console.log(err)
				})
      }
     
    },
    listXingShiInfo() {
      var data={
        caseId:this.$route.query.caseid,
					token:this.token,
          type:5
				}
				listXingShiInfo(data)
				.then( res =>{
          this.listCaseFeeId = res.data.obj[0].id
          const starContent = JSON.parse(res.data.obj[0].content)
          this.Starenvoy = starContent.contentInfo
          this.StarenvoyTime = starContent.hours
          this.tolerantPrice = starContent.tolerantPrice || ''
          this.tolerantPricecurrency = starContent.tolerantPricecurrency || 'RMB'
          console.log(this.caseDetails.obj.subIncidentType)
          console.log(JSON.parse(res.data.obj[0].content).contentInfo)
				})
				.catch( err =>{
					console.log(err)
				})
    },
    listCaseFee() {
      var data={
        caseId:this.$route.query.caseid,
					token:this.token,
          type:2
				}
				listCaseFee(data)
				.then( res =>{
          this.listCaseFeeId = res.data.obj[0].id
          console.log(this.caseDetails.obj.subIncidentType)
          if(this.caseDetails.obj.subIncidentType == 100) {
            if(JSON.parse(JSON.parse(res.data.obj[0].content).contentInfo).length >= 9) {
              this.contentInfoList = JSON.parse(JSON.parse(res.data.obj[0].content).contentInfo)
            }
          }
          if(this.caseDetails.obj.subIncidentType == 200) {
            if(JSON.parse(JSON.parse(res.data.obj[0].content).contentInfo).length >= 2) {
              this.contentInfoList = JSON.parse(JSON.parse(res.data.obj[0].content).contentInfo)
            }
          }
          if(this.caseDetails.obj.subIncidentType == 400) {
            if(JSON.parse(JSON.parse(res.data.obj[0].content).contentInfo).length >= 13) {
              this.contentInfoList = JSON.parse(JSON.parse(res.data.obj[0].content).contentInfo)
            }
              
             
          }
         
       
        console.log(this.contentInfoList)
				
				})
				.catch( err =>{
					console.log(err)
				})
    },
    editCaseRescueInfo(row) {
      this.editName = 2
      this.rescueName = row.content.rescueName
      this.fee = row.content.fee
      this.selected = JSON.stringify(row.content.selected) 
      this.serviceproviderid = row.id
      this.dialogFormVisible = true
      console.log(row.content)
    },
    delCaseRescueInfo(row) {
      var data={
					caseId:this.caseid,
					token:JSON.parse(window.localStorage.getItem("data")).data,
          infoId:row.id
				}
				delCaseRescueInfo(data)
				.then( res =>{
          this.$message({
									message: '删除成功',
									type: 'success'
								});
        this.listRescueInfo()
				
				})
				.catch( err =>{
					console.log(err)
				})
    },
    listRescueInfo() {
      var data1={
					caseId:this.$route.query.caseid,
					token:this.token,
          type:3
				}
				listRescueInfo(data1)
				.then( res =>{
          console.log(res)
          for(var i=0;i<res.data.obj.length;i++){
          res.data.obj[i].content = JSON.parse(res.data.obj[i].content)
				}
					this.tableData1=res.data.obj;
        
				})
				.catch( err =>{
					console.log(err)
				})
    },
   
    saveCaseRescueInfo() {
      var data={
          infoId:this.serviceproviderid,
					caseId:this.caseid,
					token:JSON.parse(window.localStorage.getItem("data")).data,
          time:'',// 时间
          rescueName:this.rescueName,// 服务方 
          fee:this.fee,// //费用
          selected:this.selected // 是否选择
				}
				saveCaseRescueInfo(data)
				.then( res =>{
        this.listRescueInfo()
          console.log(res.data.obj)
				
				})
				.catch( err =>{
					console.log(err)
				})
    },
    see(url) {
       window.open(url)
    },
    attach(id) {
        var data={
					caseId:this.caseid,
					token:JSON.parse(window.localStorage.getItem("data")).data,
          type:6,
          parentId:id
				}
				listAttach(data)
				.then( res =>{
          this.gridData = JSON.parse(res.data.obj[0].content)
          this.dialogFormVisible3 = true
          console.log(res.data.obj)
				
				})
				.catch( err =>{
					console.log(err)
				})
    },
    onSubmit() {
        console.log('submit!');
      },
			getTimeStr(){

			},
			getData(){
        var data={
					caseId:this.$route.query.caseid,
					token:this.token,
          type:1
				}
				listTrack(data)
				.then( res =>{
          console.log(res.data.obj,'11111111111111111111111')
          for(var i=0;i<res.data.obj.length;i++){
          // console.log(eval('(' + res.data.obj[i].content + ')'))
          res.data.obj[i].content = JSON.parse(res.data.obj[i].content)
				}
					this.tableData=res.data.obj;
          console.log(this.tableData)
				})
				.catch( err =>{
					console.log(err)
				})
       
			},
			setPoint(num){
				return getObj.pt2txt(num).node
			},
			setTime(str){
				return getObj.time(str)
			},
		
			requestFile(param) {
				this.uploadBtn=true;
				var fileObj = param.file
				let config = {
					headers: {
						"Content-Type": "multipart/form-data"
					}
				};
				var form = new FormData() // FormData 对象
				var token = JSON.parse(window.localStorage.getItem("data")).data
				form.append('file', fileObj) // 文件对象
				form.append('token', token) // 文件对象
				axios.post(SEVSRS + 'rescue/case/upload_file', form, config)
					.then(res => {
						if (res.data.code == 0) {
							this.fileUrl.push(res.data.obj);
							this.uploadBtn=false;
						}
					})
					.catch(err => {
						console.log(err)
					})
			},
			//上传
			handleRemove(file, fileList) {
        console.log(this.fileInd)
        console.log(this.fileUrl)
        this.fileUrl.splice(this.fileInd, 1);
        console.log(this.fileUrl)
			},
			handlePreview(file) {
				console.log(file);
			},
			handleExceed(files, fileList) {
				this.$message.warning(`当前限制选择 10 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			},
			beforeRemove(file, fileList) {
        for (let i = 0; i < fileList.length; i++) {
          if (JSON.stringify(fileList[i].uid) === JSON.stringify(file.uid)) {
            this.fileInd = i
          }
       }
				return this.$confirm(`确定移除 ${ file.name }？`);
			},
			beforeAvatarUpload(file) {
				const isLt8M = file.size / 1024 / 1024 < 8;
				if (!isLt8M) {
					this.$message.error('上传头像图片大小不能超过 8MB!');
				}
				return isLt8M;
			},
			uploadFile(){
        console.log(this.fileUrl)
        // return
				// if(this.fileUrl.length<1){
				// 	this.$message.error('请添加附件!');
				// }else{
         
            var data = {
              caseId:this.$route.query.caseid, //案件ID
              time:new Date(this.time).getTime(), //时间
              serviceName:this.serviceName, //服务方 
              serviceContent:this.serviceContent, //处理详情 
              urls:JSON.stringify(this.fileUrl), //附件
              token:JSON.parse(window.localStorage.getItem("data")).data
            }
            console.log(data)
          
           saveCaseTrack(data)
							.then( res =>{
								this.$message({
									message: '附件上传成功',
									type: 'success'
								});
                this.time = '', //时间
                this.serviceName = '', //服务方 
                this.serviceContent= '', //处理详情 
								this.desc='';
								this.fileList=[];
								this.fileUrl=[];
								this.updialog=false;
								this.getData();
							}).catch( err =>{
								console.log(err)
							})
				// }

			},
   
    supplierAddition() {
       this.editName=1
       this.serviceproviderid = ''
       this.editName = 2
        this.rescueName = ''
        this.fee = ''
        this.selected = ''
       this.dialogFormVisible = true
    },
    setTxt(str, status) {
      if (constants.setTxt(str, status)) {
        return constants.setTxt(str, status);
      } else {
        return str;
      }
    },
    setTime(str) {
      return constants.time(str);
    },
    getCopss() {
      // this.tableData = [];
      // this.tableData1 = [];
      var data = {
        token: this.token,
        caseId: this.caseId || this.$route.query.caseid,
      };
      caseProgress(data)
        .then((res) => {
          console.log(res);
          var reg = /(.*)\.(jpg|gif|bmp|png)$/;
          res.data.obj.reverse();
          res.data.obj.forEach((item) => {
            if (item.obj.opPhotoUrls) {
              item.obj.opPhotoUrlsArr = JSON.parse(item.obj.opPhotoUrls);
              item.obj.opPhotoUrlsArr.forEach((item1) => {
                if (reg.test(item1.url)) {
                  item1.status = 1;
                } else {
                  item1.status = 0;
                }
              });
            }
          });
          // res.data.obj.forEach((item) => {
          //   if (item.dict.chkPt <= 90) {
          //     this.tableData1.push(item);
          //   } else {
          //     this.tableData.push(item);
          //   }
          // });

          console.log(this.tableData);
        })
        .catch((err) => {
          console.log(err);
        });
      console.log(this.detailList.obj.obj.caseState);
      getNodeDataRegulator(data)
        .then((res) => {
          if (!res.data.obj) {
            this.mongeyObj = {};
            this.labelForFive = 1;
            this.otherFeeBoss = [];
            return;
          }
          this.mongeyObj = res.data.obj;
          listBidding(data)
            .then((res) => {
              this.otherFeeBoss = res.data.obj;
              this.otherFeeBoss.forEach((item) => {
                //mongeyObj
                if (!item.solution) return;
                if (item.solution.id == this.mongeyObj.id) {
                  item.check = true;
                }
              });
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getData1() {
      var data = {
        token: this.token,
        caseId: this.$route.query.caseid,
      };
      getCasedetail(data)
        .then((res) => {
          console.log(res);
          this.caseDetails = res.data.obj;
          if(this.caseDetails.obj.rescueFee != null && this.caseDetails.obj.rescueFee != undefined ) {
            this.rescueFee = this.caseDetails.obj.rescueFee  ////成本   
          }
          if(this.caseDetails.obj.medicFee != null && this.caseDetails.obj.medicFee != undefined ) {
            this.medicFee = this.caseDetails.obj.medicFee  ////成本   
          }
          if(this.caseDetails.obj.otherFee != null && this.caseDetails.obj.otherFee != undefined ) {
            this.otherFee = this.caseDetails.obj.otherFee  ////成本   
          }
          if(this.caseDetails.obj.currency != null && this.caseDetails.obj.currency != undefined ) {
            this.currency = this.caseDetails.obj.currency  ////成本   
          }
          if(this.caseDetails.obj.currency2 != null && this.caseDetails.obj.currency2 != undefined ) {
            this.currency2 = this.caseDetails.obj.currency2  ////成本   
          }
          if(this.caseDetails.obj.currency3 != null && this.caseDetails.obj.currency3 != undefined ) {
            this.currency3 = this.caseDetails.obj.currency3  ////成本   
          }
          if(this.caseDetails.obj.subIncidentType == 300) {
            this.listXingShiInfo()
          }else {
            this.listCaseFee()
          }
          this.stepData = res.data.obj2;
          this.shijiMoney = res.data.obj.feelst[0];
          this.afterMoney = res.data.obj.obj;
          this.caseState = res.data.obj.obj.caseState;
        })
        .catch((err) => {
          console.log(err);
        });
      caseProgress(data)
        .then((res) => {
          console.log(res);
          var reg = /(.*)\.(jpg|gif|bmp|png)$/;
          res.data.obj.reverse();
          res.data.obj.forEach((item) => {
            if (item.obj.opPhotoUrls) {
              item.obj.opPhotoUrlsArr = JSON.parse(item.obj.opPhotoUrls);
              item.obj.opPhotoUrlsArr.forEach((item1) => {
                if (reg.test(item1.url)) {
                  item1.status = 1;
                } else {
                  item1.status = 0;
                }
              });
            }
          });
          // res.data.obj.forEach((item) => {
          //   if (item.dict.chkPt <= 90) {
          //     this.tableData1.push(item);
          //   } else {
          //     this.tableData.push(item);
          //   }
          // });

          console.log(this.tableData);
        })
        .catch((err) => {
          console.log(err);
        });

      getNodeDataRegulator(data)
        .then((res) => {
          this.mongeyObj = res.data.obj;
          listBidding(data)
            .then((res) => {
              this.otherFeeBoss = res.data.obj;
              this.otherFeeBoss.forEach((item) => {
                //mongeyObj
                if (!item.solution) return;
                if (item.solution.id == this.mongeyObj.id) {
                  item.check = true;
                }
              });
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  watch: {
    detailList() {
      console.log(this.detailList);

      if (this.detailList.obj.obj.incidentType == "") return;
      this.typeId = this.detailList.obj.obj.incidentType;
      this.getCopss();
      console.log(this.detailList);
      this.caseDetails = this.detailList.obj;
      this.afterMoney = this.detailList.obj.obj;
      this.caseState = this.detailList.obj.obj.caseState;
      if (this.detailList.obj2) {
        this.stepData = this.detailList.obj2;
      }
      if (!this.detailList.obj.feelst || this.detailList.obj.feelst.length == 0)
        return;
      this.shijiMoney = this.detailList.obj.feelst[0];
    },
  },
};
</script>

<style scoped="scoped">
.titleH3 {
  margin: 10px 0;
  font-weight: normal;
  text-align: center;
}
.nav {
  display: flex;
  justify-content: space-between;
  background: #f2f5f8;
  padding: 5px 10px;
  margin-top: 20px;
}
.nav li {
  cursor: pointer;
  padding: 10px;
}
.active {
  background: white;
  color: #22b6fb;
}
.first {
  margin-top: 20px;
  font-size: 18px;
  margin-bottom: 20px;
}
.jbxx {
  margin-left: 35px;
  margin-top: 10px;
}
.jbxx ul {
  margin-left: 25px;
  overflow: hidden;
  min-width: 900px;
}
.jbxx ul > li {
  float: left;
  width: 30%;
  margin-top: 10px;
  overflow: hidden;
  white-space: nowrap;
  /* text-overflow: ellipsis; */
}
.jbxx1 ul > li {
  width: 50%;
}
.fwqd {
  overflow: hidden;
}
.fwqd p {
  float: left;
  margin-right: 10px;
}
.fwqd .img {
  background: url(../../assets/img/checkyes.png) no-repeat left center;
  padding-left: 20px;
}
.fwqd .imgNo {
  background: url(../../assets/img/checkno.png) no-repeat left center;
  padding-left: 20px;
}
.table {
  margin-top: 20px;
}
.img1 {
  width: 40px;
}
.item {
  float: left;
  color: #666;
  font-size: 16px;
  width: calc(30% - 20px);
}
.item span {
  padding-right: 20px;
}
ul.area {
  width: 100%;
  margin-top: 30px;
}
ul.area li {
  overflow: hidden;
  margin-bottom: 20px;
}
ul.area li > p {
  margin-bottom: 10px;
}
ul.area li > div {
  width: calc(100% - 130px);
  overflow: hidden;
  margin-left: 30px;
}
ul.area li > div > p {
  float: left;
  width: 205px;
  padding-bottom: 10px;
}
ul.area li > div > p.long {
  width: 400px;
}
ul.area li > div > p span {
  color: #ff7200;
}
</style>



// WEBPACK FOOTER //
// src/components/cmd_center/createfinishDetails.vue